import React, { useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export default function ManageCredentials({ handleClose }) {
    const [apiKey, setApiKey] = useState('AA11-AA11-AA11-AA11');
    const [environment, setEnvironment] = useState('Production');
    const [showApiKey, setShowApiKey] = useState(false);
    const [status, setStatus] = useState('idle'); // idle | loading | success
    const [message, setMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);

    const handleTest = () => {
        setStatus('loading');
        setTimeout(() => {
            setStatus('success');
            setTimeout(() => setStatus('idle'), 1200); // reset after animation
        }, 1000);
    };

    const handleSave = () => {
        setMessage('Credentials saved successfully!');
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 2000); // hide after 2s
    };

    const handleCancel = () => {
        handleClose();
    };

    const containerStyle = {
        width: '100%',
        maxWidth: '700px',
        margin: '0 auto',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    };

    const headerStyle = {
        padding: '24px 32px',
        borderBottom: '1px solid #e0e0e0',
    };

    const titleStyle = {
        margin: 0,
        fontSize: '24px',
        fontWeight: 400,
        color: '#333',
    };

    const contentStyle = {
        padding: '32px',
    };

    const fieldGroupStyle = {
        marginBottom: '24px',
    };

    const labelStyle = {
        display: 'block',
        marginBottom: '8px',
        fontSize: '14px',
        fontWeight: 500,
        color: '#333',
    };

    const inputWrapperStyle = {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
    };

    const inputStyle = {
        width: '100%',
        padding: '10px 40px 10px 12px',
        fontSize: '14px',
        border: '1px solid #d0d0d0',
        borderRadius: '4px',
        outline: 'none',
        fontFamily: 'monospace',
        letterSpacing: '0.5px',
    };

    const selectStyle = {
        width: '100%',
        maxWidth: '300px',
        padding: '10px 12px',
        fontSize: '14px',
        border: '1px solid #d0d0d0',
        borderRadius: '4px',
        backgroundColor: '#fff',
        cursor: 'pointer',
        outline: 'none',
    };

    const iconButtonStyle = {
        position: 'absolute',
        right: '10px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#666',
    };

    const buttonGroupStyle = {
        padding: '16px 32px',
        borderTop: '1px solid #e0e0e0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    };

    const validateButtonStyle = {
        padding: '8px 24px',
        fontSize: '14px',
        fontWeight: 500,
        border: '1px solid #d0d0d0',
        borderRadius: '4px',
        backgroundColor: '#f5f5f5',
        cursor: 'pointer',
        color: '#333',
    };

    const actionButtonsStyle = {
        display: 'flex',
        gap: '12px',
    };

    const closeButtonStyle = {
        padding: '8px 24px',
        fontSize: '14px',
        fontWeight: 500,
        border: '1px solid #d0d0d0',
        borderRadius: '4px',
        backgroundColor: '#fff',
        cursor: 'pointer',
        color: '#333',
    };

    const saveButtonStyle = {
        padding: '8px 24px',
        fontSize: '14px',
        fontWeight: 500,
        border: 'none',
        borderRadius: '4px',
        backgroundColor: '#2979ff',
        color: '#fff',
        cursor: 'pointer',
    };

    return (
        <div style={containerStyle}>
            <div style={headerStyle}>
                <h2 style={titleStyle}>Manage Credentials — Loqate</h2>
            </div>

            <div style={contentStyle}>
                <div style={fieldGroupStyle}>
                    <label style={labelStyle}>API Key</label>
                    <div style={inputWrapperStyle}>
                        <input
                            type={showApiKey ? 'text' : 'password'}
                            value={apiKey}
                            onChange={(e) => setApiKey(e.target.value)}
                            style={inputStyle}
                        />
                        <button
                            style={iconButtonStyle}
                            onClick={() => setShowApiKey(!showApiKey)}
                            type="button"
                        >
                            {showApiKey ? (
                                <VisibilityOffIcon style={{ fontSize: '20px' }} />
                            ) : (
                                <VisibilityIcon style={{ fontSize: '20px' }} />
                            )}
                        </button>
                    </div>
                </div>

                <div style={fieldGroupStyle}>
                    <label style={labelStyle}>Environment</label>
                    <select
                        value={environment}
                        onChange={(e) => setEnvironment(e.target.value)}
                        style={selectStyle}
                    >
                        <option value="Production">Production</option>
                        <option value="Development">Development</option>
                        <option value="Staging">Staging</option>
                    </select>
                </div>

                <div style={fieldGroupStyle}>
                    <label style={labelStyle}>Validate</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                        <button
                            type='button'
                            onClick={handleTest}
                            style={validateButtonStyle}
                            disabled={status === 'loading'}
                            onMouseEnter={(e) => { (e.target.style.backgroundColor = '#ccf1a2ff') }}
                            onMouseLeave={(e) => { (e.target.style.backgroundColor = '#f5f5f5') }}
                        >
                            Test
                        </button>

                        {/* Loader or Success Icon */}
                        {status === 'loading' && (
                            <div
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    border: '3px solid #2563EB',
                                    borderTop: '3px solid transparent',
                                    borderRadius: '50%',
                                    animation: 'spin 1s linear infinite',
                                }}
                            />
                        )}

                        {status === 'success' && (
                            <div
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '50%',
                                    border: '2px solid #22c55e',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    animation: 'fadeIn 0.3s ease-in-out',
                                }}
                            >
                                <div
                                    style={{
                                        width: '5px',
                                        height: '10px',
                                        borderBottom: '2px solid #22c55e',
                                        borderRight: '2px solid #22c55e',
                                        transform: 'rotate(45deg)',
                                    }}
                                />
                            </div>
                        )}

                        <style>
                            {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }

          @keyframes fadeIn {
            from { opacity: 0; transform: scale(0.8); }
            to { opacity: 1; transform: scale(1); }
          }
        `}
                        </style>
                    </div>

                </div>
            </div>

            <div style={buttonGroupStyle}>
                <div style={actionButtonsStyle}>
                    <button onClick={handleCancel} style={closeButtonStyle}>
                        Close
                    </button>
                    <button onClick={handleSave} style={saveButtonStyle}>
                        Save
                    </button>

                    {showAlert && (
                        <div
                            style={{
                                position: 'fixed',
                                top: '20px',
                                right: '20px',
                                backgroundColor: '#2563EB',
                                color: 'white',
                                padding: '0.75rem 1.5rem',
                                borderRadius: '0.5rem',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                                transition: 'opacity 0.3s',
                            }}
                        >
                            {message}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}